<template>
    <svg
        height="24px"
        width="24px"
        id="bank"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27.768 27.869"
        style="fill: currentColor"
    >
        <path
            id="Tracé_52"
            data-name="Tracé 52"
            d="M368.927,220.854h5.118v9.038h-5.118Z"
            transform="translate(-348.89 -208.829)"
        />
        <path
            id="Tracé_53"
            data-name="Tracé 53"
            d="M208.927,220.854h5.118v9.038h-5.118Z"
            transform="translate(-197.602 -208.829)"
        />
        <path
            id="Tracé_54"
            data-name="Tracé 54"
            d="M27.062,416.854H2.56a1.635,1.635,0,0,0-1.633,1.634v1.906a1.635,1.635,0,0,0,1.633,1.634h24.5a1.635,1.635,0,0,0,1.633-1.634v-1.906A1.635,1.635,0,0,0,27.062,416.854Z"
            transform="translate(-0.927 -394.157)"
        />
        <path
            id="Tracé_55"
            data-name="Tracé 55"
            d="M27.672,5.128,15.418.117a1.627,1.627,0,0,0-1.219,0L1.951,5.128A1.626,1.626,0,0,0,.927,6.643V8.758A1.635,1.635,0,0,0,2.56,10.391h24.5A1.635,1.635,0,0,0,28.7,8.758V6.643A1.626,1.626,0,0,0,27.672,5.128ZM15.628,6.09a.817.817,0,1,1-1.633,0V4.348a.817.817,0,0,1,1.633,0Z"
            transform="translate(-0.927 0)"
        />
        <path
            id="Tracé_56"
            data-name="Tracé 56"
            d="M48.927,220.854h5.118v9.038H48.927Z"
            transform="translate(-46.314 -208.829)"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-bank",
});
</script>
